import { useState } from 'react';

import { Box, Button, Grid } from '@mui/material';

import { back } from '@redwoodjs/router';

import { PARTNER_SUB_NAVIGATION } from 'src/constants';
import { useAddPartnerContext } from 'src/contexts/AddPartnerProvider';

import SubNavigation from '../components/Navigation/SubNavigation';

type SummaryTypes = {};

export const Summary: React.FC<SummaryTypes> = () => {
    const [lastStep, setLastStep] = useState('');
    const { submitPartnerApplication, setActiveStep } = useAddPartnerContext();

    const handleCancel = () => {
        // Delete partial/complete partner record?
        setActiveStep(0);
        back();
    };
    return (
        <Box display="flex" flexDirection="column" gap="24px">
            <Grid
                item
                xs={12}
                sx={{
                    border: '1px solid #F18F34',
                    backgroundColor: '#FFFFFF',
                    boxShadow: '0px 4px 20px rgba(38, 50, 56, 0.1)',
                    borderRadius: '16px',
                    padding: '32px 24px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    gap: '24px',
                    paddingTop: '0',
                    paddingRight: '0',
                    paddingLeft: '0',
                }}
                container
            >
                <SubNavigation steps={PARTNER_SUB_NAVIGATION} setLastStep={setLastStep} />
            </Grid>
            {lastStep === 'contractInformation' ? (
                <Box display="flex" justifyContent="flex-end">
                    <Button
                        sx={{
                            alignSelf: 'end',
                            marginTop: '24px',
                            marginRight: '22px',
                        }}
                        onClick={handleCancel}
                        data-testid={`add-partner-cancel-button`}
                        variant="back-button"
                    >
                        Cancel
                    </Button>
                    <Button
                        sx={{
                            alignSelf: 'end',
                            marginTop: '24px',
                        }}
                        data-testid={`add-partner-create-partner-button`}
                        onClick={async () => await submitPartnerApplication()}
                        variant="main"
                    >
                        Create Partner
                    </Button>
                </Box>
            ) : null}
        </Box>
    );
};
